<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('products.productGroups.form.name')"
            is-required
        >
            <DInput
                id="name"
                v-model="form.name"
                :placeholder="__('products.productGroups.form.name')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('name')"
                :invalid-feedback="errors.name"
                maxlength="191"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.productGroups.form.brands')"
            is-required
        >
            <DMultiSelect
                id="brands"
                v-model:options="brandOptions"
                :search="true"
                :selected="form.product_brands"
                :selection="true"
                :options-empty-placeholder="__('products.productGroups.form.no_options_found')"
                :search-placeholder="__('products.productGroups.form.assign_brands')"
                selection-type="text"
                :is-valid="isFormFieldValid('product_brands')"
                :invalid-feedback="errors.product_brands"
                @update="updateSelectedBrands"
            />
            <p
                v-if="errors['product_brands']"
                class="invalid-feedback d-block"
            >
                <span>
                    {{ errors['product_brands'] }}<br>
                </span>
            </p>
        </DFormRow>
        <DFormRow :label="__('products.productGroups.form.retired')">
            <div
                role="group"
                class="form-group"
            >
                <DSwitch
                    id="switch-retired"
                    v-model="form.retired"
                    color="success"
                    variant="3d"
                />
            </div>
        </DFormRow>
        <DFormRow :label="__('products.productGroups.form.limit_to_one_addon')">
            <div
                role="group"
                class="form-group"
            >
                <DSwitch
                    id="switch-limit-to-one-addon"
                    v-model="form.limit_to_one_addon"
                    color="success"
                    variant="3d"
                />
            </div>
        </DFormRow>
        <DFormRow
            :label="__('products.productGroups.form.public')"
            :hint="__('products.productGroups.form.public_hint')"
        >
            <div
                role="group"
                class="form-group"
            >
                <DSwitch
                    id="switch-addon-group-public"
                    v-model="form.public"
                    color="success"
                    variant="3d"
                />
            </div>
        </DFormRow>
        <RetiredWarningModal
            :show="showRetiredWarningModal"
            :linked-products="linkedProducts"
            translation-key="products.productGroups.retired_warning_modal"
            @confirm="submitFormAfterRetiredWarning"
            @close="showRetiredWarningModal = false"
        />
        <DFormControls
            :cancel-route="cancelRoute"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
import RetiredWarningModal from '~@/Components/Products/RetiredWarningModal.vue'

export default {
    name: 'ProductAddonGroupForm',
    components: {
        RetiredWarningModal
    },
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        productGroup: {
            type: Object,
            default: () => {
                return {}
            }
        },
        allProductGroups: {
            type: Array,
            default () {
                return []
            }
        },
        selectedChildGroups: {
            type: Array,
            default () {
                return []
            }
        },
        selectedParentGroups: {
            type: Array,
            default () {
                return []
            }
        },
        brands: {
            type: Array,
            default () {
                return []
            }
        },
        selectedProductGroupBrands: {
            type: Array,
            default () {
                return []
            }
        },
        linkedProducts: {
            type: Array,
            default () {
                return []
            }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                name: this.productGroup?.name ?? null,
                retired: this.productGroup?.retired ?? false,
                product_brands: this.selectedProductGroupBrands ?? [],
                limit_to_one_addon: this.productGroup.limit_to_one_addon,
                public: this.productGroup.public
            }),
            showRetiredWarningModal: false
        }
    },
    computed: {
        cancelRoute () {
            return this.$route('products.product-addons.index')
        },
        brandOptions () {
            return this.brands.map((item) => {
                return { value: item.value, text: item.label, selected: this.selectedProductGroupBrands.includes(item.value) }
            })
        }
    },
    methods: {
        submitForm () {
            if (this.form.retired && !this.productGroup?.retired && this.linkedProducts.length > 0) {
                this.showRetiredWarningModal = true
                return
            }

            this.$emit('form-submitted', this.form)
        },
        submitFormAfterRetiredWarning () {
            this.showRetiredWarningModal = false
            this.$emit('form-submitted', this.form)
        },
        updateSelectedBrands (values) {
            this.form.product_brands = values
        }
    }
}
</script>

<style scoped>
    .group-selection {
        display: flex;
        align-items: center;
        width: 100%;
    }
    .retired-toggle-label {
        margin-bottom: 0;
        padding-left: 5px;
    }
    .retired-toggle {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        margin-left: 10px
    }
</style>
